/**
 * iOS: 入力フォーカス時の自動ズームを防ぐ（フォーカス時のみ maximum-scale=1 を付与）
 * 入力以外ではピンチズームが有効なままになる。
 * @see https://gist.github.com/OysteinAmundsen/9e6b2ebdf8264ec0e25a0540661949bc
 */
const FORM_TAGS = ["INPUT", "SELECT", "TEXTAREA"];

function isFormControl(el: EventTarget | null): el is HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement {
  return el instanceof HTMLElement && FORM_TAGS.includes(el.tagName);
}

function getViewportMeta(): HTMLMetaElement | null {
  return document.querySelector('meta[name="viewport"]');
}

function setViewportScale(enable: boolean) {
  const meta = getViewportMeta();
  if (!meta) return;
  let content = meta.getAttribute("content") ?? "";
  if (enable) {
    if (content.includes("maximum-scale=1")) return;
    meta.setAttribute("content", `${content},maximum-scale=1`.replace(/,,/g, ","));
  } else {
    if (!content.includes("maximum-scale=1")) return;
    content = content.replace(/,?\s*maximum-scale=1\s*/g, "").replace(/,,/g, ",").trim();
    meta.setAttribute("content", content);
  }
}

function checkAndRestoreViewport() {
  const active = document.activeElement;
  if (!isFormControl(active)) setViewportScale(false);
}

export function initIosInputZoomFix() {
  if (typeof document === "undefined") return;
  if (!/iPhone|iPad|iPod/.test(navigator.userAgent)) return;
  const meta = getViewportMeta();
  if (!meta) return;

  document.body.addEventListener(
    "focusin",
    (e) => {
      if (isFormControl(e.target)) setViewportScale(true);
    },
    { passive: true }
  );

  document.body.addEventListener(
    "focusout",
    () => {
      setTimeout(checkAndRestoreViewport, 0);
    },
    { passive: true }
  );
}
